import { merge } from "lodash-es";
import { useMemo } from "react";

export type DisplayProps = Record<string, any>;

/** Resolves final display props.
 * @param displayProps - Display props array from least to most specific.
 */
export function useDisplayProps<TDisplayProps extends DisplayProps>(
  displayPropsList: Array<Partial<TDisplayProps> | null | undefined>,
): TDisplayProps {
  const displayPropsComputed = useMemo(() => merge({}, ...displayPropsList), [...displayPropsList]);
  return displayPropsComputed;
}
